import * as React from 'react';
import { Outlet } from 'react-router-dom';

const Prize: React.FC = () => {
  return <Outlet />;
};

export default Prize;
